import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Login from './components/Login';
import Register from './components/Register';
import ExpedientesList from './components/ExpedientesList';
import ExpedienteDetail from './components/ExpedienteDetail';
import ExpedienteForm from './components/ExpedienteForm';
import ExpedienteEditForm from './components/ExpedienteEditForm';
import Configuracion from './components/Configuracion';
import Dashboard from './components/Dashboard';
import DashboardAvanzado from './components/DashboardAvanzado';
import ParteAsignadaGestion from './components/ParteAsignadaGestion';
import NotificationsPanel from './components/NotificationsPanel';
import NotificationToasts from './components/NotificationToasts';
import PendingApproval from './components/PendingApproval';
import Calendario from './components/Calendario';
import CalendarioAcceso from './components/CalendarioAcceso';
import Herramientas from './components/Herramientas';
import RegistrosIncompletos from './components/RegistrosIncompletos';
import PapeleraArchivos from './components/PapeleraArchivos';
import AppPageLayout from './components/AppPageLayout';
import AppFondoApplicator from './components/AppFondoApplicator';
import './App.css';
import './styles/global.css';
import './styles/pendientes-modal.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <ToastProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <div className="App">
              <AppFondoApplicator />
              <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pending-approval" element={<PendingApproval />} />
            
            {/* Rutas protegidas — / queda libre en nginx (catálogo); el gestor vive en /expedientes */}
            <Route path="/" element={<Navigate to="/expedientes" replace />} />
            <Route path="/expedientes" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <ExpedientesList />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/expedientes/nuevo" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <ExpedienteForm />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/expedientes/:id" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <ExpedienteDetail />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/expedientes/:id/editar" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <ExpedienteEditForm />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/configuracion" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <Configuracion />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <Dashboard />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/dashboard-avanzado" element={
              <ProtectedRoute requireJefe={true}>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <DashboardAvanzado />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/mis-partes-asignadas/:parteId" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <ParteAsignadaGestion />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/calendario" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <CalendarioAcceso />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/herramientas" element={
              <ProtectedRoute>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <Herramientas />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/registros-incompletos" element={
              <ProtectedRoute requireJefe={true}>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <RegistrosIncompletos />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
            <Route path="/papelera" element={
              <ProtectedRoute requireJefeOrAdmin={true}>
                <>
                  <Header />
                  <Navigation />
                  <AppPageLayout>
                    <PapeleraArchivos />
                  </AppPageLayout>
                </>
              </ProtectedRoute>
            } />
              </Routes>
              
              {/* Componentes de notificaciones */}
              <NotificationsPanel />
              <NotificationToasts />
            </div>
          </Router>
        </ToastProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
